import { Component } from 'react';
import { compose } from 'redux';
import isUndefined from 'transmute/isUndefined';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error untyped module
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped module
import { isResolved } from 'reference-resolvers/utils';

// @ts-expect-error untyped module
import { ReferenceNameView } from 'customer-data-reference-ui-components/name/ReferenceName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { inboundDbObjectUrlByObjectTypeId } from 'automation-ui-references/routing/hubspotUrls';
import WiredCustomObjectResolver from 'automation-ui-enrollment/components/common/WiredCustomObjectResolver';
import MarketingStatus from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/MarketingStatus';
import MergeStatus from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/MergeStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UIListSmartDivider = styled(UIList).withConfig({
  displayName: "ObjectNameReference__UIListSmartDivider",
  componentId: "sc-1i0raif-0"
})(["&&{> li:first-child:empty{display:none;& + li{padding-left:0;background:none;}}}"]);
const getRecordProperties = reference => {
  let properties = {};
  if (reference && isResolved(reference) && reference.referencedObject && reference.referencedObject.get('properties')) {
    properties = reference.referencedObject.get('properties').toJS();
  }
  return properties;
};

/**
 *
 * Example:
 *   <ObjectName id={123} objectTypeId={ObjectTypeIds.DEAL_ID} />
 * Renders as:
 *   My Deal Name
 */
export class ObjectNameReference extends Component {
  constructor(...args) {
    super(...args);
    this.onResolved = ({
      reference
    }) => {
      if (reference.archived) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.history.object-name.deleted-object",
          options: {
            objectName: reference.label
          }
        });
      }
      return reference.label;
    };
    this.getLinkAddress = () => {
      const {
        id,
        objectTypeId,
        href,
        reference
      } = this.props;
      if (!reference || reference.archived) {
        return null;
      }
      if (href) {
        return href;
      }
      if (isUndefined(href)) {
        return inboundDbObjectUrlByObjectTypeId(objectTypeId, id, getRecordProperties(reference));
      }
      return null;
    };
  }
  render() {
    const {
      id,
      objectTypeId,
      mergeAuditCutoff,
      messageKey,
      className,
      showMergeStatus,
      showNonMarketingStatus,
      reference,
      disableTruncateString = false
    } = this.props;

    // the resolver, and therefore the reference, will be undefined until the
    // object type definition loads
    if (isUndefined(reference)) {
      return /*#__PURE__*/_jsx(SkeletonText, {});
    }
    const ReferenceName = /*#__PURE__*/_jsx(ReferenceNameView, {
      id: id,
      referenceObjectType: objectTypeId,
      href: this.getLinkAddress(),
      onUnknown: ({
        referenceObjectType
      }) => /*#__PURE__*/_jsx("i", {
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.history.object-name.no-object-name_cob",
          objectTypeId: referenceObjectType
        })
      }),
      messageKey: messageKey,
      className: className,
      reference: reference,
      onResolved: this.onResolved
    });
    if (!reference || !showNonMarketingStatus && !showMergeStatus) {
      return ReferenceName;
    }

    /**
     * Force the UITruncateString here so we don't render a tooltip within tooltip
     * for the marketing contacts scenario.
     */
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [!disableTruncateString ? /*#__PURE__*/_jsx(UITruncateString, {
        tooltip: reference && reference.label,
        children: ReferenceName
      }) : ReferenceName, /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(UIListSmartDivider, {
          inline: true,
          use: "inline-divided",
          children: [showMergeStatus && /*#__PURE__*/_jsx(MergeStatus, {
            reference: reference,
            objectTypeId: objectTypeId,
            mergeAuditCutoff: mergeAuditCutoff
          }), showNonMarketingStatus && /*#__PURE__*/_jsx(MarketingStatus, {
            reference: reference
          })]
        })
      })]
    });
  }
}
const mapResolversToProps = (__resolvers, {
  resolver,
  id
}) => {
  // the resolver will be undefined until the object type definition loads
  return resolver ? {
    reference: resolver.byId(id)
  } : {};
};
export default compose(WiredCustomObjectResolver, ResolveReferences(mapResolversToProps))(ObjectNameReference);